import request from '@/utils/request'

/**
 *上传位文件
 * @param {*} data 
 */
export function upload(data){
    return request({
        url: '/file/upload',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/img.js